import React from "react";
import NtSetupResourceList from "../NtSetupResourceList";
import NtSetupResourceCard from "../NtSetupResourceCard";
import NtRingGroupNewForm from "../../../extensions/components/NtRingGroupNewForm";
import { fetchRingGroups } from "../../../api/ringgroup";
import settings from "../../../config/settings";

const fetcher = (domain) =>
  fetchRingGroups(domain, 1, settings.pageSizeLoad || 50);

const parseItems = (response) =>
  response?.data?.data || response?.data?.ringgroups || [];

function NtSetupRingGroupsStep() {
  return (
    <NtSetupResourceList
      icon="phone-incoming-outline"
      title="Ring groups"
      subtitle="Optional — shared inbound routing"
      addLabel="Add ring group"
      emptyTitle="No ring groups yet"
      emptySubtitle="Group extensions so a single number rings several phones — handy for Sales, Support or front desk."
      fetcher={fetcher}
      parseItems={parseItems}
      renderItem={(item, index) => (
        <NtSetupResourceCard
          key={item.ring_group_uuid || item.id || index}
          badge={item.ring_group_extension || item.extension}
          title={item.ring_group_name || item.name || "Ring group"}
          subtitle={
            item.ring_group_description ||
            item.description ||
            item.ring_group_strategy
          }
        />
      )}
      renderForm={({ onCancel, onCreate }) => (
        <NtRingGroupNewForm onCancel={onCancel} onCreate={onCreate} />
      )}
    />
  );
}

export default NtSetupRingGroupsStep;
